import path from 'path';

export function getThumb(orig: string, size = 500, format = 'jpeg') {
	const pp = path.parse(orig);
	return `${pp.dir}/${pp.name}.${size}.${format}`;
}
